/**
 * @file 申诉
 * @author zhaomiaoyuan
 */
import React, {useEffect, useCallback} from 'react';
import {connect} from 'react-redux';
import {withRouter, Prompt} from 'react-router-dom';
import PropTypes from 'prop-types';

import StepsMenu from '../../components/StepsMenu/index.tsx';
import Step1 from './step1.jsx';
import Step2 from './step2.jsx';
import Step3 from './step3.jsx';

import {
    fetchAppealSearch,
    updateAppeal,
    cleanAppeal,
    fetchAppealGov,
    fetchAppealPerson,
    fetchAppealCompany
} from '../../actions/appealAction';
import {
    fetchSendCode,
    fetchUserInfo
} from '../../actions/attestAction';
import {appealSubTitle, appealTitle, appealBannerClass} from './conf';
import {recordProxy, bCat_2055_request, getQueryString, handleLogin} from '../../util';
import imgPhoneEdit from './imgs/phone-edit.png';
import imgCertifyEdit from './imgs/certify-edit.png';
import imgSubmitSuccess from './imgs/submit-success.png';
import imgPhoneEditNormal from './imgs/phone-edit-normal.png';
import imgCertifyEditNormal from './imgs/certify-edit-normal.png';
import imgSubmitSuccessNormal from './imgs/submit-success-normal.png';

import './index.less';

export const Appeal = (props) => {
    const {
        appealData,
        updateAppeal,
        cleanAppeal,
        fetchAppealSearch
    } = props;

    const getAppealType = useCallback(() => {
        if (location.pathname.indexOf('occupy') !== -1) {
            updateAppeal({
                appealType: 2 // 占用申诉
            });
        } else {
            updateAppeal({
                appealType: 1 // 标记申诉
            });
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
        getAppealType();
        handleLogin(props.fetchUserInfo);
        return () => {
            cleanAppeal();
        };
    }, [location.pathname, getAppealType]);

    const getOccupyTitle = (data) => {
        if (data.mode === 'customer') {
            return data.list.find(item => item.title)?.title;
        } else if (data.mode === 'poi') {
            return data.list.find(item => item.name)?.name;
        }
        return '';
    };
    const searchFn = (data) => {
        appealData.appealType === 2
            ? recordProxy('occupy', 'click', 'search')
            : recordProxy('appeal', 'click', 'search');

        const fetchAppealSearchFn = (params) => fetchAppealSearch({
            ...params,
            search: data.phone.replace(/\s+/g, '')
        }).then(res => {
            const isOccupy = data.appealType === 2;
            const isMark = data.appealType === 1;
            if (res?.code === 200 && res?.data.list.length > 0) {
                if (isMark && !(res.data.mode === 'reports' || res.data.mode === 'poi')) {
                    // 标记申诉不匹配
                    updateAppeal({
                        phone: data.phone,
                        phoneErr: '该号码暂无标记，无需申诉'
                    });
                    return;
                } else if (isOccupy
                    && res.data.mode !== 'customer'
                    && res.data.mode !== 'poi'
                ) {
                    // 占用申诉不匹配
                    updateAppeal({
                        phone: data.phone,
                        phoneErr: '该号码暂无占用，无需申诉'
                    });
                    return;
                }
                // 占用申诉且路由有参数：号码标签，否则为空
                // const phoneName = isOccupy
                //     ? (data.hasSearchUrl ? data.phoneName : getPhoneName(res.data))
                //     : '';
                const phoneName = isOccupy && data.hasSearchUrl
                    ? data.phoneName || getPhoneName(res.data)
                    : '';
                // 号码标记：号码标签；占用申诉：企业名称；
                const titleName = isOccupy
                    ? getOccupyTitle(res.data)
                    : data.hasSearchUrl && data.phoneName
                        ? data.phoneName
                        : getPhoneName(res.data);

                updateAppeal({
                    phone: data.phone.replace(/\s+/g, ''),
                    phoneName,
                    phoneErr: '',
                    curStep: 2,
                    titleName: titleName
                });
                window.scrollTo(0, 0);
            } else if (res?.code === 200 && res?.data.list.length === 0) {
                updateAppeal({
                    phone: data.phone,
                    phoneErr: isOccupy ? '该号码暂无占用，无需申诉' : '该号码暂无标记，无需申诉'
                });
            } else {
                updateAppeal({
                    phone: data.phone,
                    phoneErr: res?.message
                });
            }
        });
        bCat_2055_request(fetchAppealSearchFn);
    };
    const getPhoneName = data => {
        if (!data) {
            return '';
        }
        const dataInfo = data?.list[0];
        let phoneName = '';
        switch(data.mode) {
            case 'customer':
                phoneName = dataInfo.key || dataInfo.title;
                break;
            case 'reports':
                phoneName = dataInfo.tag;
                break;
            case 'poi':
                phoneName = dataInfo.name;
                break;
        }
        return phoneName;
    };
    useEffect(() => {
        const searchUrl = getQueryString('phones');
        let phoneListTemp = [];
        if (searchUrl) {
            try {
                phoneListTemp = JSON.parse(decodeURIComponent(getQueryString('phones')));
                updateAppeal({
                    phoneList: phoneListTemp,
                    hasSearchUrl: !!searchUrl.length
                });
                searchFn({
                    phone: phoneListTemp[0].phone,
                    phoneName: phoneListTemp[0].name,
                    hasSearchUrl: !!searchUrl.length,
                    appealType: location.pathname.indexOf('occupy') !== -1 ? 2 : 1
                });
            } catch (e) {
                console.log(e);
            }
        }

    }, [location.search, getQueryString]);

    const stepList = [
        {
            title: '1.填写号码信息',
            imgNormal: imgPhoneEditNormal,
            img: imgPhoneEdit
        },
        {
            title: '2.填写证明信息',
            imgNormal: imgCertifyEditNormal,
            img: imgCertifyEdit
        },
        {
            title: '3.提交等待审核',
            imgNormal: imgSubmitSuccessNormal,
            img: imgSubmitSuccess
        }
    ];

    const nonempty = () => {
        if (appealData.curStep === 3) {
            return false;
        }

        return appealData.phone !== ''
            || appealData.phoneName !== ''
            || appealData.companyName !== ''
            || appealData.cert.length > 0
            || appealData.companyQualify.length > 0
            || appealData.social.length > 0
            || appealData.companyAddress !== ''
            || appealData.nameGov !== ''
            || appealData.email !== ''
            || appealData.emailCode !== ''
            || appealData.isRead;
    };

    return (
        <div className={'appeal-major'}>
            <div className="banner">
                <div className={'carousel-item ' + appealBannerClass[appealData.appealType]}>
                    <div className="item-info-wrapper">
                        <p className="title">{appealTitle[appealData.appealType]}</p>
                        <p className="title-tip">{appealSubTitle[appealData.appealType]}</p>
                    </div>
                </div>
                <div className="banner-bottom"></div>
            </div>

            <div className="steps-menu">
                <StepsMenu data={stepList} curStep={appealData.curStep} />
            </div>
            <div className="appeal-major-content">
                {appealData.curStep === 1 && <Step1 {...props} searchFn={searchFn} />}
                {appealData.curStep === 2 && <Step2 {...props} />}
                {appealData.curStep === 3 && <Step3 {...props} />}
            </div>
            <Prompt
                when={nonempty()}
                message={() => {
                    return  '是否不提交信息进行跳转？';
                }}
            />
        </div>
    );
};

Appeal.propTypes = {
    history: PropTypes.object,
    fetchAppealSearch: PropTypes.func,
    updateAppeal: PropTypes.func,
    cleanAppeal: PropTypes.func,
    appealData: PropTypes.object,
    fetchSendCode: PropTypes.func,
    location: PropTypes.object,
    fetchUserInfo: PropTypes.func
};

function mapStateToProps(state) {
    return {
        appealData: state.appealReducer
    };
}

function mapDispatchToProps(dispatch) {
    return {
        fetchAppealSearch: obj => fetchAppealSearch(dispatch, obj),
        fetchSendCode: obj => fetchSendCode(dispatch, obj),
        updateAppeal: obj => updateAppeal(dispatch, obj),
        cleanAppeal: () => cleanAppeal(dispatch),
        fetchAppealPerson: obj => fetchAppealPerson(dispatch, obj),
        fetchAppealGov: obj => fetchAppealGov(dispatch, obj),
        fetchAppealCompany: obj => fetchAppealCompany(dispatch, obj),
        fetchUserInfo: obj => fetchUserInfo(dispatch, obj)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Appeal));
